module.exports = "@media (min-width: 768px) {\r\n.login-page{\r\n    background-size: contain;\r\n    width: 1309px;\r\n    height: 610px;   \r\n    margin-left: -10px;\r\n}\r\n\r\n#loginbox{    \r\n    margin-left: 403px\r\n}\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/components/admin-login/admin-login.component.css
// module id = ./src/app/admin/components/admin-login/admin-login.component.css
// module chunks = main